import { addMinutes, format, isBefore, parse } from "date-fns";

const DateTimeHelper = {
	formatDate(date: Date) {
		return format(date, "dd/MM/yyyy '-' HH:mm:ss");
	},

	isValidDate(date: Date) {
		return date instanceof Date && !Number.isNaN(date.getTime());
	},

	addMinutesToTime(
		time: Date | string,
		minutes: number,
		targetFormat = "HH:mm"
	) {
		return String(
			format(
				addMinutes(parse(String(time), "HH:mm:ss", new Date()), minutes),
				targetFormat
			)
		);
	},

	dateBeforeToday(date: string | undefined) {
		if (!date) return false;

		const inputDate = parse(date, "yyyy-MM-dd", new Date());
		const today = new Date();

		inputDate.setHours(0, 0, 0, 0);
		today.setHours(0, 0, 0, 0);

		return isBefore(inputDate, today);
	},

	getCurrentDate() {
		const currentDate = new Date();
		const day = currentDate.getDate();
		const month = currentDate.getMonth() + 1;
		const year = currentDate.getFullYear();
		return `${year}-${month.toString().padStart(2, "0")}-${day
			.toString()
			.padStart(2, "0")}`;
	},

	dateBefore(date: string | undefined, targetDate: string) {
		if (!date) return false;

		const inputDate = parse(date, "yyyy-MM-dd", new Date());
		const target = parse(targetDate, "yyyy-MM-dd", new Date());

		return isBefore(inputDate, target);
	}
};

export default DateTimeHelper;
